import { AxiosResponse } from 'axios';
import { useMutation, useQuery } from 'react-query';
import apiClient from '../apiClient/apiClient';
import { AddEditClassSizeRequestBody, ClassSize, EditSizeRequestBody, Size } from './size.types';

export const useSizes = (enabled: boolean = false) => {
  return useQuery<AxiosResponse<Size[]>>({
    queryKey: 'sizes',
    queryFn: () => apiClient.get<Size[]>('/sizes'),
    enabled,
  });
};

export const useSize = (requestBody: { sizeNo: string }, enabled: boolean = false) => {
  return useQuery<AxiosResponse<Size>>({
    queryKey: ['size', requestBody.sizeNo],
    queryFn: () => apiClient.get<Size>(`/sizes/${requestBody.sizeNo}`, { params: requestBody }),
    enabled,
  });
};

export const useEditSize = (sizeNo: string) => {
  return useMutation((requestBody: EditSizeRequestBody) => {
    return apiClient.put(`/sizes/${sizeNo}`, requestBody);
  });
};

export const useClassSizes = (
  requestBody: { classNo?: string; sizeNo?: string; status?: number },
  enabled: boolean = false
) => {
  return useQuery<AxiosResponse<ClassSize[]>>({
    queryKey: ['sizes', requestBody.classNo, requestBody.sizeNo, requestBody.status],
    queryFn: () => apiClient.get<ClassSize[]>('/class-sizes', { params: requestBody }),
    enabled,
  });
};

export const useAddClassSize = () => {
  return useMutation(( requestBody: AddEditClassSizeRequestBody ) => {
    return apiClient.post<ClassSize>(`/class-sizes?classNo=${requestBody.classNo}&sizeNo=${requestBody.sizeNo}`, requestBody );
  });
};

export const useDeleteClassSize = () => {
  return useMutation((classNoAndSizeNo: {classNo: number | undefined, sizeNo: number | undefined}) => {
    return apiClient.delete(`/class-sizes/${classNoAndSizeNo.classNo}`, { params:  {sizeNo: classNoAndSizeNo.sizeNo} });
  });
};

export const useGetRecipeSizes = (
    requestBody: { classNo: string; baseNo: string},
    enabled: boolean = false
) => {
  return useQuery<AxiosResponse<Size[]>>({
    queryKey: ['getRecipeSizes', requestBody.classNo, requestBody.baseNo],
    queryFn: () => apiClient.get<Size[]>('/recipes/sizes', { params: requestBody }),
    enabled
  });
};

export const useGetSubRecipeSizes = (
    requestBody: { classNo: string; baseNo?: string },
    enabled: boolean = false
) => {
  return useQuery<AxiosResponse<Size[]>>({
    queryKey: ['getSubRecipeSizes', requestBody.classNo, requestBody.baseNo],
    queryFn: () => apiClient.get<Size[]>('/sub-recipes/sizes', { params: requestBody }),
    enabled
  });
};

export const useGetMenuItemRecipeSizes = (
  menuNo: string,
  requestBody: { classNo?: number; baseNo?: number; strategyNo?: string },
  enabled: boolean = false
) => {
  return useQuery<AxiosResponse<Size[]>>({
    queryKey: ['getMenuItemRecipeSizes', menuNo, requestBody.classNo, requestBody.baseNo, requestBody.strategyNo],
    queryFn: () => apiClient.get<Size[]>(`/menus/${menuNo}/items/recipes/sizes`, { params: requestBody }),
    enabled
  });
};

export const useGetMenuItemSubRecipeSizes = (
  menuNo: string,
  requestBody: { classNo?: number; baseNo?: number },
  enabled: boolean = false
) => {
  return useQuery<AxiosResponse<Size[]>>({
    queryKey: ['getMenuItemSubRecipeSizes', menuNo, requestBody.classNo, requestBody.baseNo],
    queryFn: () => apiClient.get<Size[]>(`/menus/${menuNo}/items/sub-recipes/sizes`, { params: requestBody }),
    enabled
  });
};
